import {
    endOfMonth,
    format,
    formatISO,
    getQuarter,
    getYear,
    startOfMonth,
    startOfQuarter,
    startOfYear,
    subMonths,
    subQuarters,
    subYears,
} from "date-fns";

export interface DateOnlyPeriod {
    startDate: string;
    endDate: string;
}

export function getLastCompletedMonthDates(now = new Date()): DateOnlyPeriod {
    const lastMonth = subMonths(startOfMonth(now), 1);
    return {
        startDate: formatISO(lastMonth, { representation: "date" }),
        endDate: formatISO(endOfMonth(lastMonth), { representation: "date" }),
    };
}

export type PeriodType = "month" | "quarter" | "year" | "custom";

export function getDefaultPeriodValue(
    type: Exclude<PeriodType, "custom">,
): string {
    const now = new Date();
    switch (type) {
        case "month":
            return format(subMonths(startOfMonth(now), 1), "yyyy-MM");
        case "quarter": {
            const lastQ = subQuarters(startOfQuarter(now), 1);
            return `${getYear(lastQ)}-Q${getQuarter(lastQ)}`;
        }
        case "year":
            return String(getYear(subYears(startOfYear(now), 1)));
    }
}
